import { useState, useEffect, useRef } from "react";
import { FilterHeadingTab } from "../../components/Filters";
import "./home.css";
import { ReactComponent as Logo } from "../../icons/IGX_logo.svg";
import GasAnalyticsLogo from '../../icons/Logo.png';
import "../styles.css";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as UserIcon } from "../../icons/user-circle.svg";
import { ReactComponent as LogOut } from "../../icons/logout.svg";
import { COLOR_CODES, isMobile } from "../../common";
import { getUser, logout } from "../Protected";
import { Demand } from "./consumption-generation/Demand";
import Home from "./home";
import { DynamicDatePicker } from "../../components/DatePicker";
import ElectricityPar from "./electricity-par";




const TABS_GROUP = [
  {
    "headline": "Collective",
    "tabs": ["Market Analysis", "Electricity Parameters"
    ]
  },

];

export function HomePage() {
  const [tab, setTab] = useState(TABS_GROUP[0].tabs[0]);
  const navigate = useNavigate();
  const location = useLocation();
  const [dates, setDates] = useState<{
    startDate: Date;
    endDate: Date;
    key: string;
  }>({
    startDate: new Date(new Date().setDate(new Date().getDate() - 38)),
    endDate: new Date(new Date().setDate(new Date().getDate() - 9)),
    key: "selection",
  });

  useEffect(() => {
    // Set the initial tab based on the URL
    const tabFromUrl = new URLSearchParams(location.search).get("tab") as any;
    if (TABS_GROUP.flatMap((value) => value.tabs).includes(tabFromUrl)) {
      setTab(tabFromUrl);
    }
  }, []);

  useEffect(() => {
    // Update the URL whenever the tab changes
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    navigate({ search: params.toString() }, { replace: true });
  }, [tab]);

  return (
    <div className="page-wrapper">
      <div className="header">
        <div style={{width: '430px'}}>
        <a href="https://www.mcxindia.com/" target="_blank">
        <img src={GasAnalyticsLogo} className="logo-icon" />
        </a>
        </div>
        
        <div className="gas-tabs">
          {/* <FilterHeadingTab
            isSingle={true}
            options={TABS_GROUP}
            selected={[tab]}
            onClick={(newTab) => {
              if (tab !== newTab) {
                setTab(newTab); // Update the tab only if it changes
              }
            }}
          /> */}
          <h1 className="text-2xl font-bold " style={{color: COLOR_CODES.secondary}}>Electricity Analytics 
          </h1>
        </div>
        <div className="flex items-center gap-x-5  justify-end">
          <div className="desktop-date-picker">
            <DynamicDatePicker
              defaultDates={dates}
              setDate={(dateArray) => {
                if (dateArray && dateArray.length > 0) {
                  const selectedDates = dateArray[0];
                  console.log('Selected dates:', selectedDates);
                  setDates(selectedDates); // Take the first (and only) date range
                }
              }}
            />
          </div>
          <a href="https://gna.energy/" target="_blank">
          <img  src={'https://gna-general-files.s3.ap-south-1.amazonaws.com/Website+Assetss/GNA%20Logo.png'} className="logo-icon" />
          </a>
          {/* <Logo className="logo-icon" /> */}
          {/* <UserMenu /> Use the isolated UserMenu component */}
        </div>
        <div className="date-picker-container">
          <DynamicDatePicker
            defaultDates={dates}
            setDate={(dateArray) => {
              if (dateArray && dateArray.length > 0) {
                const selectedDates = dateArray[0];
                console.log('Selected dates:', selectedDates);
                setDates(selectedDates); // Take the first (and only) date range
              }
            }}
          />
        </div>
      </div>
{
  tab === "Market Analysis" && <Home startDate={dates.startDate.toISOString().split('T')[0]} endDate={dates.endDate.toISOString().split('T')[0]} />
}    
{
  tab ==="Electricity Parameters" && <ElectricityPar startDate={dates.startDate.toISOString().split('T')[0]} endDate={dates.endDate.toISOString().split('T')[0]} />
}

        {/* {tab === "Demand" && <Demand />} */}
     {/* {tab === "IGX" && <Daily />}
      {tab === "Daily" && <Daily />}
      {tab === "Consumption" && <Consumption />}
      {tab === "Production" && <Production />}
      {tab === "Import" && <GasImport />}
      {tab === "Consumption vs Production" && <ConsumptionProduction />}
      {tab === "CGD" && <CGD />}
      {tab === "CBG" && <CBG />}
      {tab === "LNG Terminals" && <LNGTerminals />}
      {tab === "Pipelines" && <Pipeline />} 
      {tab === "Summary" && <PowerStationAnalysis />}
      {tab === "Plant-Wise" && <PowerStationByDate />}asdas */}
    </div>
  );
}

export function UserMenu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false); // Close the menu if clicked outside
      }
    }

    // Add event listener to detect clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function _handleLogOut() {
    logout();
    window.location.href = "/login";
  }

  function toggleMenu(event: React.MouseEvent) {
    setMenuOpen(!menuOpen)
  }

  return (
    <div className="user-menu-container" ref={menuRef}>
      {!isMobile && (
        <UserIcon
          className="cursor-pointer"
          width={45}
          height={45}
          fill={COLOR_CODES.secondary}
          onClick={toggleMenu} // Use toggleMenu to handle click
        />
      )}
      {/* {menuOpen && (
        <div className="user-menu" >
          <p>{getUser().email}</p>
          <p
            onClick={_handleLogOut}
            className="mt-2 flex items-center justify-between cursor-pointer"
          >
            Logout <LogOut width={14} height={14} fontWeight={700} />
          </p>
        </div>
      )} */}
      {/* {isMobile && (
        <UserIcon
          className="cursor-pointer mobile-user-icon"
          width={40}
          height={40}
          fill={COLOR_CODES.secondary}
          onClick={toggleMenu} // Use toggleMenu for mobile too
        />
      )} */}
    </div>
  );
}
